module.exports = __webpack_public_path__ + "static/media/Control-V.17e03e4e.png";